import { DataService } from './data.service';
import { OptionService } from './bohrpunkte/option.service';
import { EvaluationService } from './bohrpunkte/evaluation.service';
import { ValidationService } from './bohrpunkte/validation.service';
import { AuthService } from './auth.service';
import { FilterService } from './filter.service';
import { first } from 'rxjs/operators';
import { ConnectionService, GpsService, MapStatusService, MdbService, StorageService, ViewportService, OfflineModeService, UpdateService, SplashScreenService, GlobalTileSeedService, MBTilesService } from '@luzula/luzula-lib';
import { ProjectService } from './project.service';

export function initServicesFactory(
	cs: ConnectionService,
	us: UpdateService,
	gps: GpsService,
	as: AuthService,
	ds: DataService,
	ps: ProjectService,
	es: EvaluationService,
	fs: FilterService,
	mapStatus: MapStatusService,
	mdb: MdbService,
	oms: OfflineModeService,
	os: OptionService,
	storage: StorageService,
	vs: ValidationService,
	vps: ViewportService,
	splash: SplashScreenService,
	tileSeed: GlobalTileSeedService,
	mbtiles: MBTilesService
) {
	return async () => {
		splash.updateStatus('Offline-Einstellungen prüfen...');

		// ZUERST: Offline-Modus aus Storage lesen
		const userOfflineMode = await oms.initFromStorage();

		// OSM-Basiskarte (z7-11) aus MBTiles laden
		splash.updateStatus('Basiskarte laden...');
		await mbtiles.load('/assets/osm-base.mbtiles');

		if (userOfflineMode) {
			// Wenn Benutzer explizit Offline-Modus aktiviert hat,
			// keine Netzwerk-Checks durchführen
			splash.updateStatus('Offline-Modus aktiv');
			as.init(false, true);
			return;
		}

		// Sonst: Normale Initialisierung mit Netzwerk-Check
		splash.updateStatus('Netzwerkverbindung prüfen...');
		cs.monitor().pipe(first()).subscribe((online: boolean) => {
			splash.updateStatus(online ? 'Anmeldung prüfen...' : 'Offline starten...');
			as.init(online, true);
		});
	};
}
